import { AppConstants } from '@utils/app.constants';
import { LMFieldPickerComponent, LMFieldPickerService } from '@app/components';
import { LMFormatUtilService } from '@app/services';

export const lmFieldPickerFormatter = (
  lmFieldPickerService: LMFieldPickerService,
  lmFormatUtilService: LMFormatUtilService,
  searchFromContext: Array<UIFieldSpec>,
  nameSearch: string,
  isKey: boolean,
  row: number,
  cell: number,
  value: any,
  columnDef: ListGridColumn,
  uiFieldSpec: UIFieldSpec,
  dataGrid: SohoDataGridStatic
): string => {

  let displayText: string;
  const hasSearchCriteria = !(!nameSearch || nameSearch.trim().length === 0);

  if (columnDef.displayField.isTreeColumn) {
    const searchFrom = searchFromContext?.length > 0 ? searchFromContext[searchFromContext.length -1] : undefined;
    let displayValue =  hasSearchCriteria ? lmFieldPickerService.getUIFieldSpecSearchName(uiFieldSpec, searchFrom) : value;

    if (hasSearchCriteria && uiFieldSpec.depth === 1) {
      const searchInfo = nameSearch.split('.');

      if (searchInfo.length === 1) {
        displayValue = lmFieldPickerService.boldQuery(displayValue, nameSearch);
      } else {
        displayValue = lmFieldPickerService.boldQuery(displayValue, searchInfo[searchInfo.length - 1]);
      }

    }

    displayText = Soho.Formatters.Tree(row, cell, displayValue, columnDef, uiFieldSpec, dataGrid);
  } else if (columnDef.displayField.type === AppConstants.TEXT) {
    displayText = Soho.Formatters.Ellipsis(row, cell, value, columnDef, uiFieldSpec, dataGrid);
  }

  if (columnDef.id === LMFieldPickerComponent.LABEL_COLUMN_ID && isKey) {
    const tooltip = lmFormatUtilService.formatMessage(Soho.Locale.translate('FieldPicker_KeyForText'), uiFieldSpec.businessClass);

    return `<span title="${tooltip}">` +
        `<svg class="icon datagrid-alert-icon icon-${'info'}" focusable="false" aria-hidden="true" role="presentation">` +
        `<use xlink:href="#icon-${'info'}"></use></svg></span>` +
        `<span class="datagrid-alert-text">${displayText}</span>`;
  }

  if (columnDef.id === LMFieldPickerComponent.TYPE_COLUMN_ID) {
    switch (uiFieldSpec.fieldType) {
      case 'TEXT': return Soho.Locale.translate('FieldPicker_text_type_label');
      case 'BOOLEAN': return Soho.Locale.translate('FieldPicker_boolean_type_label');
      case 'NUMBER': return Soho.Locale.translate('FieldPicker_number_type_label');
      case 'DATE': return Soho.Locale.translate('FieldPicker_date_type_label');
      case 'BINARYOBJECT': return Soho.Locale.translate('FieldPicker_binary_type_label');
      case 'STATE': return Soho.Locale.translate('FieldPicker_state_type_label');
      case 'GROUP': return Soho.Locale.translate('FieldPicker_Group_type_label');
      case 'ARRAY': return Soho.Locale.translate('FieldPicker_array_type_label');
      case 'OTO_RELATION': return Soho.Locale.translate('FieldPicker_otorelation_type_label');
      case 'OTM_RELATION': return Soho.Locale.translate('FieldPicker_otmrelation_type_label');
      default: return Soho.Locale.translate('FieldPicker_other_type_label');
    }
  }

  return displayText;
};

export const lmFieldPickerHyperLinkFormatter = (
  lmFieldPickerService: LMFieldPickerService,
  row: number,
  cell: number,
  value: any,
  columnDef: ListGridColumn,
  uiFieldSpec: UIFieldSpec,
  dataGrid: SohoDataGridStatic
): string => {

  if (columnDef.id === LMFieldPickerComponent.SEARCH_FROM_HERE_COLUMN_ID) {
    if (uiFieldSpec.hasChildren
    &&  uiFieldSpec.relatedBusinessClass
    && !uiFieldSpec.isStateField
    && uiFieldSpec.fieldType !== 'GROUP'
    && uiFieldSpec.fieldType !== 'ARRAY') {
      return Soho.Formatters.Hyperlink(row, cell, value, columnDef, uiFieldSpec, dataGrid);
    }
    return '';
  }
};
